import React from "react";

export const Home = ({  height="64px",padding="12px", width="98px",style={}})=> (
    <svg   role='presentation' aria-label='' style={style} padding ={padding} height={height}  viewBox="0 0 98 64" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="Illustration-Home">
                <g id="Group-19">
                    <g id="Group-8" transform="translate(0.000000, 0.750000)">
                        <g id="Group" transform="translate(13.500000, 0.000000)">
                            <polygon id="Shape" fill="#FFD871" fill-rule="nonzero" points="66.75 61.5 3 61.5 3 25.0213205 34.9163424 1.5 66.75 25.0213205"></polygon>
                            <polygon id="Shape" fill="#FFCA53" fill-rule="nonzero" points="18.6054687 13.5 3 24.9206897 3 61.5 66.75 61.5"></polygon>
                            <polyline id="Shape" stroke="#85949B" stroke-width="3" stroke-linecap="square" points="0 26.25 35.2912281 0 70.5 26.25"></polyline>
                            <polygon id="Rectangle-path" fill="#9FB7C1" fill-rule="nonzero" points="15.75 33.75 30.75 33.75 30.75 61.5 15.75 61.5"></polygon>
                            <polygon id="Rectangle-path" fill="#32A0DA" fill-rule="nonzero" points="39.75 33.75 54.75 33.75 54.75 51 39.75 51"></polygon>
                            <polygon id="Rectangle-path-Copy" fill="#2990C7" fill-rule="nonzero" points="39.75 34.5288908 54.75 49.563197 54.75 51 39.75 51"></polygon>
                        </g>
                        <path d="M0,61.5 L97.125,61.5" id="Shape" stroke="#CAD9E0" stroke-width="0.75" stroke-linecap="round"></path>
                    </g>
                </g>
                <path d="M60.4589481,34.5 L60.4589481,51.75" id="Path-5" stroke="#D9E4EB"></path>
                <path d="M60.75,35.625 L60.75,50.625" id="Path-5-Copy" stroke="#D9E4EB" transform="translate(60.750000, 43.125000) rotate(-270.000000) translate(-60.750000, -43.125000) "></path>
            </g>
        </g>
    </svg>
);
